/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_Bo as Bo,
  rec_Componente_f0_102_48 as Componente_f0_102_48,
  rec_Componente_p0_112_48 as Componente_p0_112_48,
  rec_DetalleIncidencia as DetalleIncidencia,
  rec_EstadoError as EstadoError,
  rec_JSXRuntime as JSXRuntime,
  rec_Modal as Modal,
  rec_React as React,
  rec_ResolverObservacion as ResolverObservacion,
  rec_Sn as Sn,
  rec_a0 as a0,
  rec_api as api,
  rec_c0 as c0,
  rec_fC as fC,
  rec_ii as ii,
  rec_l0 as l0,
  rec_puedeInspecciones as puedeInspecciones,
} from "../../runtime/index.jsx";
import { EstadoObservacion, FichaObservacion } from "./FichaObservacion.jsx";
export function PendientesPorLevantar() {
  let [e, t] = (0, React.useState)(null),
    [n, r] = (0, React.useState)(``),
    [i, a] = (0, React.useState)(``),
    [o, s] = (0, React.useState)(null),
    [c, l] = (0, React.useState)(0),
    [porAprobar, setPorAprobar] = (0, React.useState)(0),
    u = (0, React.useCallback)(async () => {
      a(``);
      try {
        let [e, r] = await Promise.all([
          api(`/pendientes${n ? `?origen=${n}` : ``}`, {
            sinCache: !0,
          }),
          puedeInspecciones()
            ? api(`/inspecciones/observaciones/resumen`, {
                sinCache: !0,
              }).catch(() => null)
            : Promise.resolve(null),
        ]);
        (t(e ?? []), l(r?.borradores ?? 0), setPorAprobar(r?.porAprobar ?? 0));
      } catch (e) {
        a(e.message);
      }
    }, [n]);
  ((0, React.useEffect)(() => {
    u();
  }, [u]),
    (0, React.useEffect)(
      () =>
        fC(() => u(), {
          entidad: `INCIDENCIA`,
        }),
      [u],
    ));
  let f = (0, React.useMemo)(() => c0(e), [e]);
  return i && !e ? (
    <EstadoError mensaje={i} onReintentar={u} />
  ) : e ? (
    <div
      className={`flex flex-col gap-4`}
      children={[
        <EstadoError mensaje={i} onReintentar={u} />,
        <div
          className={`grid ${porAprobar > 0 ? `grid-cols-3` : `grid-cols-2`} gap-3`}
          children={[
            <div
              className={Bo}
              children={[
                <p
                  className={`text-xs text-(--text)`}
                  children={`Por levantar`}
                />,
                <p
                  className={`text-2xl font-semibold text-(--text-h)`}
                  children={f.pendientes}
                />,
              ]}
            />,
            <div
              className={Bo}
              children={[
                <p
                  className={`text-xs text-(--text)`}
                  children={`Pasadas de fecha`}
                />,
                <p
                  className={`text-2xl font-semibold ${f.vencidas ? `text-(--error)` : `text-(--text-h)`}`}
                  children={f.vencidas}
                />,
              ]}
            />,
            porAprobar > 0 && (
              <div className={Bo} children={[
                <p className={`text-xs text-(--text)`} children={`Por aprobar`} />,
                <p className={`text-2xl font-semibold text-(--text-h)`} children={porAprobar} />,
              ]} />
            ),
          ]}
        />,
        <div
          className={`flex flex-wrap gap-1 border-b border-(--border)`}
          children={l0.map((e) => (
            <button
              key={e.id || `todo`}
              type={`button`}
              onClick={() => r(e.id)}
              className={`-mb-px min-h-11 border-b-2 px-3 py-2 text-sm transition ${n === e.id ? `border-(--accent) font-medium text-(--text-h)` : `border-transparent text-(--text) hover:text-(--text-h)`}`}
              children={e.label}
            />
          ))}
        />,
        c > 0 && (
          <div
            className={`rounded-2xl border border-(--border) bg-(--bg) p-4 flex flex-col gap-2 border-(--warning-border) bg-(--warning-bg)`}
            children={[
              <p
                className={`text-sm font-medium text-(--text-h)`}
                children={
                  c === 1
                    ? `Hay 1 acta sin firmar`
                    : `Hay ${c} actas sin firmar`
                }
              />,
              <p
                className={`text-sm text-(--text)`}
                children={`Lo que se encontró en ellas aparece acá cuando se firma el acta.`}
              />,
              <Sn
                to={`/inspecciones`}
                className={`text-sm font-medium text-(--accent) hover:underline`}
                children={`Ir a terminarlas`}
              />,
            ]}
          />
        ),
        e.length === 0 ? (
          c === 0 && (
            <p
              className={`rounded-2xl border border-(--border) bg-(--bg) p-4 text-sm text-(--success)`}
              children={`No queda nada por levantar. Todo lo que se encontró está resuelto.`}
            />
          )
        ) : (
          <JSXRuntime.Fragment
            children={[
              <ul
                className={`flex flex-col gap-2 sm:hidden`}
                children={e.map((e) => (
                  <li
                    key={`${e.origen}-${e.id}`}
                    children={
                      <button
                        type={`button`}
                        onClick={() => s(e)}
                        className={`${Bo} flex w-full flex-col gap-1 text-left active:scale-[0.99]`}
                        children={[
                          <div
                            className={`flex items-start justify-between gap-2`}
                            children={[
                              <span
                                className={`text-sm font-medium text-(--text-h)`}
                                children={e.titulo}
                              />,
                              <span
                                className={`flex shrink-0 items-center gap-1`}
                                children={[
                                  <Componente_f0_102_48 valor={e.criticidad} />,
                                  <Componente_p0_112_48 p={e} />,
                                  e.estado === `POR_APROBAR` && <EstadoObservacion estado={e.estado} />,
                                ]}
                              />,
                            ]}
                          />,
                          <span
                            className={`break-words text-xs text-(--text)`}
                            children={e.detalle}
                          />,
                          <span
                            className={`text-xs text-(--text)`}
                            children={[
                              a0[e.origen],
                              e.donde ? ` · ${e.donde}` : ``,
                              e.responsable ? ` · ${e.responsable}` : ``,
                            ]}
                          />,
                        ]}
                      />
                    }
                  />
                ))}
              />,
              <div
                className={`${Bo} hidden overflow-x-auto p-0 sm:block`}
                children={
                  <table
                    className={`w-full text-left text-sm`}
                    children={[
                      <thead
                        className={`border-b border-(--border) text-xs uppercase text-(--text)`}
                        children={
                          <tr
                            children={[
                              <th
                                className={`px-3 py-2 font-medium`}
                                children={`Qué`}
                              />,
                              <th
                                className={`px-3 py-2 font-medium`}
                                children={`Detalle`}
                              />,
                              <th
                                className={`px-3 py-2 font-medium`}
                                children={`De dónde`}
                              />,
                              <th
                                className={`px-3 py-2 font-medium`}
                                children={`Dónde`}
                              />,
                              <th
                                className={`px-3 py-2 font-medium`}
                                children={`Responsable`}
                              />,
                              <th
                                className={`px-3 py-2 font-medium`}
                                children={`Gravedad`}
                              />,
                              <th
                                className={`px-3 py-2 font-medium`}
                                children={`Plazo`}
                              />,
                              <th className={`px-3 py-2`} />,
                            ]}
                          />
                        }
                      />,
                      <tbody
                        children={e.map((e) => (
                          <tr
                            key={`${e.origen}-${e.id}`}
                            className={`border-b border-(--border) last:border-0`}
                            children={[
                              <td
                                className={`px-3 py-2 text-(--text-h)`}
                                children={e.titulo}
                              />,
                              <td
                                className={`max-w-56 px-3 py-2 text-(--text)`}
                                children={e.detalle}
                              />,
                              <td
                                className={`px-3 py-2 text-(--text)`}
                                children={a0[e.origen]}
                              />,
                              <td
                                className={`px-3 py-2 text-(--text)`}
                                children={e.donde || `—`}
                              />,
                              <td
                                className={`px-3 py-2 text-(--text)`}
                                children={e.responsable || `—`}
                              />,
                              <td
                                className={`px-3 py-2`}
                                children={
                                  <Componente_f0_102_48 valor={e.criticidad} />
                                }
                              />,
                              <td
                                className={`px-3 py-2`}
                                children={e.estado === `POR_APROBAR` ? <EstadoObservacion estado={e.estado} /> : <Componente_p0_112_48 p={e} />}
                              />,
                              <td
                                className={`px-3 py-2 text-right`}
                                children={
                                  <AccionAsync
                                    variante={`texto`}
                                    className={`min-h-11`}
                                    onClick={() => s(e)}
                                    children={`Abrir`}
                                  />
                                }
                              />,
                            ]}
                          />
                        ))}
                      />,
                    ]}
                  />
                }
              />,
            ]}
          />
        ),
        o?.origen === `INCIDENCIA` && (
          <DetalleIncidencia
            id={o.id}
            onCerrar={() => s(null)}
            onCambio={async () => {
              (s(null), await u());
            }}
          />
        ),
        o?.origen === `OBSERVACION` && (
          <FichaObservacion id={o.id} onCerrar={() => s(null)} onCambio={() => u()} />
        ),
      ]}
    />
  ) : (
    <div
      className={`flex justify-center py-16 text-(--text)`}
      children={(0, JSXRuntime.jsx)(ii, {
        className: `h-6 w-6 animate-spin`,
      })}
    />
  );
}
